import React from "react";
import { getCompanyConfig } from "@/config/company";

export default function CustomerMoqPrintTemplate({ data, config }: { data: any, config: any }) {
    // data.items is the array of MOQ calculations
    const moqs = data.items || [];
    const c = getCompanyConfig(config);
    
    const formatCurrency = (val: number) => new Intl.NumberFormat("vi-VN", { style: "currency", currency: "VND" }).format(val);

    return (
        <div className="w-full bg-white print:bg-white text-black p-[10mm] font-serif text-[14px] leading-tight print:break-inside-avoid">
            <style type="text/css" media="print">
                {`@page { size: A4 portrait; margin: 0; }`}
            </style>
            
            {/* ========== TOP HEADER (ISO 9001:2015) ========== */}
            <div className="flex justify-between items-start mb-8 gap-4">
                {/* Left: Logo */}
                <div className="w-[30%] flex items-start">
                    <img src={c.logoUrl} alt="Logo" className="w-[120px] h-auto max-h-[80px] object-contain flex-shrink-0" onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }} />
                </div>

                {/* Right: Company Info */}
                <div className="w-[70%] flex flex-col items-end text-right mt-2">
                    <div className="font-bold text-[14px] uppercase leading-tight mb-1 text-slate-800">{c.companyName}</div>
                    <div className="text-[11px] text-slate-600 uppercase font-medium">{c.companyNameEn || ''}</div>
                </div>
            </div>

            <div className="mt-4 mb-8">
                <h1 className="text-2xl font-bold text-center uppercase mb-4 text-slate-900">Bảng Báo Giá</h1>
                
                <div className="space-y-2 text-[14px]">
                    <div className="flex">
                        <span className="w-24 font-bold">Kính gửi:</span>
                        <span className="border-b border-dotted border-slate-400 flex-1 ml-2">...........................................................................................................................</span>
                    </div>
                    <div className="flex">
                        <span className="w-24 font-bold">Người nhận:</span>
                        <span className="border-b border-dotted border-slate-400 flex-1 ml-2">...........................................................................................................................</span>
                    </div>
                </div>
            </div>

            <div className="mb-4 text-[14px]">
                <p>Chúng tôi xin trân trọng gửi đến Quý công ty bảng báo giá cho sản phẩm <strong>{data.productName || "..................................................."}</strong> với chi tiết như sau:</p>
            </div>

            <table className="w-full border-collapse border border-slate-400 mt-4 text-[14px] mb-8">
                <thead>
                    <tr className="bg-slate-100 print:bg-slate-100 font-bold print:text-black">
                        <td className="border border-slate-400 p-3 text-center w-12">STT</td>
                        <td className="border border-slate-400 p-3">Tên sản phẩm</td>
                        <td className="border border-slate-400 p-3 text-right">Số lượng</td>
                        <td className="border border-slate-400 p-3 text-right">Đơn giá / SP</td>
                        <td className="border border-slate-400 p-3 text-right">Thành tiền</td>
                    </tr>
                </thead>
                <tbody>
                    {moqs.map((moq: any, index: number) => (
                        <tr key={moq.quantity}>
                            <td className="border border-slate-400 p-3 text-center">{index + 1}</td>
                            <td className="border border-slate-400 p-3">{data.productName || "Sản phẩm Demo"}</td>
                            <td className="border border-slate-400 p-3 text-right">{moq.quantity.toLocaleString()}</td>
                            <td className="border border-slate-400 p-3 text-right font-semibold text-red-600 print:text-black">
                                {formatCurrency(moq.summary?.unitPrice || 0)}
                            </td>
                            <td className="border border-slate-400 p-3 text-right font-bold">
                                {formatCurrency(moq.summary?.totalPrice || 0)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="mb-8 text-[14px]">
                <p className="font-bold underline mb-2">Ghi chú:</p>
                <ul className="list-disc pl-5 space-y-1">
                    <li>Đơn giá trên chưa bao gồm thuế VAT (8%).</li>
                    <li>Thời gian giao hàng: ...... ngày kể từ ngày duyệt mẫu và tạm ứng.</li>
                    <li>Thanh toán: Tạm ứng 50%, thanh toán 50% còn lại trước khi giao hàng.</li>
                    <li>Báo giá có giá trị trong vòng 15 ngày.</li>
                </ul>
            </div>

            <div className="grid grid-cols-2 mt-16 gap-8 text-center text-[15px]">
                <div>
                    <div className="font-bold uppercase mb-20">Đại diện khách hàng</div>
                    <div className="italic text-slate-500">(Ký và ghi rõ họ tên)</div>
                </div>
                <div>
                    <div className="font-bold uppercase mb-20">Đại diện công ty</div>
                    <div className="italic text-slate-500">(Ký và ghi rõ họ tên)</div>
                </div>
            </div>
            
            {/* Spacer for signature */}
            <div className="h-12"></div>
        </div>
    );
}
